import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import ConfigModule from './modules/ConfigModule';
import AdminEventsModule from './modules/AdminEventsModule';
import AdminAbonadosModule from './modules/AdminAbonadosModule';
import AdminSimpatizantesModule from './modules/AdminSimpatizantesModule';
import AdminTaquillerosModule from './modules/AdminTaquillerosModule';
import RecintoModule from './modules/RecintoModule';
import AdminRecintosModule from './modules/AdminRecintosModule';
import AuthModule from './modules/AuthModule';
import AdminListaAbonadosModule from './modules/AdminListaAbonadosModule';
import AdminAbonosModule from './modules/AdminAbonosModule';
import FrontEventsModule from './modules/FrontEventsModule';
import FrontModule from './modules/FrontModule';
import AdminComunicadosModule from './modules/AdminComunicadosModule';
import AdminBasesModule from './modules/AdminBasesModule';
import AdminFrecuenciasModule from './modules/AdminFrecuenciasModule';
import SuperAdminModule from './modules/SuperAdminModule';
import LfpModule from './modules/LfpModule';
import FrontLfpModule from './modules/FrontLfpModule';
import AdminDescargasModule from './modules/AdminDescargasModule';
import AdminFaqsModule from './modules/AdminFaqsModule';
import FrontQuestionsAnswersModule from './modules/FrontFaqsModule';
import AdminRecordatoriosModule from './modules/AdminRecordatoriosModule';
import AdminLiquidacionesAbonosModule from './modules/AdminLiquidacionesAbonosModule'
import AdminDireccionesFiscalesModule from './modules/AdminDireccionesFiscalesModule';
import AdminLiquidacionesEventosModule from './modules/AdminLiquidacionesEventosModule'
import AdminPromocionesModule from './modules/AdminPromocionesModule';
import FrontAyudaModule from './modules/FrontAyudaModule';
import AdminPacksEventsModule from './modules/AdminPacksEventsModule';
import FrontPacksModule from './modules/FrontPacksModule';
import FrontParcelasModule from './modules/FrontParcelasModule';
import AdminMensajeriaModule from './modules/AdminMensajeriaModule';
import AdminLiquidacionesBasesModule from "@/store/modules/AdminLiquidacionesBasesModule";
import AdminTeatroModule from './modules/AdminTeatroModule';
import FrontAbonadoModule from './modules/FrontAbonadoModule';
import AdminNotificacionesModule from './modules/AdminNotificacionesModule';
import CuentaAtras from "@/store/modules/CuentaAtras";
import AdminMetodosDePago from './modules/AdminMetodosDePago';
import FrontReservasModule from './modules/FrontReservasModule';
import FrontAcreditacionesModule from './modules/FrontAcreditacionesModule';
import AdminDesgloseVentasAbonosModule from './modules/AdminDesgloseVentasAbonosModule';
import AdminUsuariosModule from './modules/AdminUsuariosModule';
import FrontTemporadaModule from './modules/FrontTemporadaModule';
import AdminCarritosModule from './modules/AdminCarritosModule';
import FrontCarritosModule from './modules/FrontCarritosModule';
import FrontProductosModule from './modules/FrontProductosModule';
import AdminLiquidacionesProductosModule from './modules/AdminLiquidacionesProductosModule'
import AdminPlantillasWhatsappModule from './modules/AdminPlantillasWhatsappModule';
import FrontSgaModule from './modules/FrontSgaModule';
import AdminSgaModule from './modules/AdminSgaModule';
import ParcelasModule from './modules/ParcelasModule';
import VincularPreciosParcelaModule from './modules/VincularPreciosParcelaModule';
import AdminLiquidacionesParcelasModule from './modules/AdminLiquidacionesParcelasModule.js';

export default new Vuex.Store({
    modules: {
        ConfigModule,
        AdminEventsModule,
        AdminCarritosModule,
        AdminSimpatizantesModule,
        AdminTaquillerosModule,
        RecintoModule,
        AuthModule,
        AdminListaAbonadosModule,
        AdminAbonosModule,
        FrontEventsModule,
        AdminComunicadosModule,
        FrontModule,
        AdminRecintosModule,
        AdminBasesModule,
        AdminFrecuenciasModule,
        SuperAdminModule,
        LfpModule,
        FrontLfpModule,
        AdminDescargasModule,
        AdminFaqsModule,
        FrontQuestionsAnswersModule,
        AdminRecordatoriosModule,
        AdminLiquidacionesAbonosModule,
        AdminDireccionesFiscalesModule,
        AdminLiquidacionesEventosModule,
        AdminPromocionesModule,
        AdminPacksEventsModule,
        FrontPacksModule,
        FrontAyudaModule,
        AdminMensajeriaModule,
        AdminLiquidacionesBasesModule,
        AdminTeatroModule,
        FrontAbonadoModule,
        AdminNotificacionesModule,
        CuentaAtras,
        AdminMetodosDePago,
        FrontReservasModule,
        FrontAcreditacionesModule,
        AdminDesgloseVentasAbonosModule,
        AdminUsuariosModule,
        FrontTemporadaModule,
        FrontCarritosModule,
        AdminAbonadosModule,
        FrontProductosModule,
        AdminLiquidacionesProductosModule,
        AdminLiquidacionesParcelasModule,
        AdminPlantillasWhatsappModule,
        FrontSgaModule,
        AdminSgaModule,
        FrontParcelasModule,
        ParcelasModule,
        VincularPreciosParcelaModule
    }
})
